import 'core-js/stable'
import 'regenerator-runtime/runtime'

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import VueScrollTo from 'vue-scrollto'
import VCalendar from 'v-calendar'
import VueDragscroll from 'vue-dragscroll'

// 汎用パーツ
import BackgroundImage from './components/partial/BackgroundImage.vue'
import DocumentLink from './components/partial/DocumentLink.vue'
import PCButtonHistoryBack from './components/pc/partial/PCButtonHistoryBack.vue'
import SPButtonHistoryBack from './components/sp/partial/SPButtonHistoryBack.vue'
import ButtonViewLater from './components/pc/partial/ButtonViewLater.vue'
import ButtonEdit from './components/pc/partial/ButtonEdit.vue'
import ButtonClose from './components/pc/partial/ButtonClose.vue'
import ButtonChangePosition from './components/pc/partial/ButtonChangePosition.vue'
import ButtonCopyOther from './components/pc/partial/ButtonCopyOther.vue'

// グローバル処理
import globalMixin from './util/global'
import handleScrollMixin from './util/handlescroll'
import menuMixin from './util/menu'
import printMixin from './util/print'
import { installGtmGaClassClickUidDelegate } from './util/gtmGaClickDelegate'

import IconMenuSvg from '@/components/svg/IcnMenu.vue'
import IconLaterSvg from '@/components/svg/IcnLater.vue'
import IconNoteSvg from '@/components/svg/IcnNote.vue'
import IconHistorySvg from '@/components/svg/IcnHistory.vue'
import IconPaperSvg from '@/components/svg/IcnPaper.vue'
import IconListSvg from '@/components/svg/IcnList.vue'
import IconList2Svg from '@/components/svg/IcnList2.vue'
import IconThemeSvg from '@/components/svg/IcnTheme.vue'
import IconSearchSvg from '@/components/svg/IcnSearch.vue'
import IcArrowDown from '@/components/svg/IcArrowDown.vue'
import IcArrowLeft from '@/components/svg/IcArrowLeft.vue'
import IcArrowRight from '@/components/svg/IcArrowRight.vue'
import IcArrowTop from '@/components/svg/IcArrowTop.vue'
import IcBookmarkOff from '@/components/svg/IcBookmarkOff.vue'
import IcBookmarkOn from '@/components/svg/IcBookmarkOn.vue'
import IcCheck from '@/components/svg/IcCheck.vue'
import IcContent from '@/components/svg/IcContent.vue'
import IcCopy from '@/components/svg/IcCopy.vue'
import IcDisplay from '@/components/svg/IcDisplay.vue'
import IcDisplayPdf from '@/components/svg/IcDisplayPdf.vue'
import IcDot from '@/components/svg/IcDot.vue'
import IcDownload from '@/components/svg/IcDownload.vue'
import IcEdit from '@/components/svg/IcEdit.vue'
import IcEraser from '@/components/svg/IcEraser.vue'
import IcExpansion from '@/components/svg/IcExpansion.vue'
import IcFalse from '@/components/svg/IcFalse.vue'
import IcHidden from '@/components/svg/IcHidden.vue'
import IcKebabMenu from '@/components/svg/IcKebabMenu.vue'
import IcKey from '@/components/svg/IcKey.vue'
import IcLastlist from '@/components/svg/IcLastlist.vue'
import IcLoading from '@/components/svg/IcLoading.vue'
import IcMenu from '@/components/svg/IcMenu.vue'
import IcMinus from '@/components/svg/IcMinus.vue'
import IcNote from '@/components/svg/IcNote.vue'
import IcNotification from '@/components/svg/IcNotification.vue'
import IcPdf from '@/components/svg/IcPdf.vue'
import IcPlus from '@/components/svg/IcPlus.vue'
import IcPrint from '@/components/svg/IcPrint.vue'
import IcRanking from '@/components/svg/IcRanking.vue'
import IcReduction from '@/components/svg/IcReduction.vue'
import IcSearch from '@/components/svg/IcSearch.vue'
import IcSeparate from '@/components/svg/IcSeparate.vue'
import IcTopdown from '@/components/svg/IcTopdown.vue'
import IcToplist from '@/components/svg/IcToplist.vue'
import IcTrue from '@/components/svg/IcTrue.vue'
import IcWatchLater from '@/components/svg/IcWatchLater.vue'


Vue.use(VueScrollTo)
Vue.use(VCalendar)
Vue.use(VueDragscroll)
Vue.mixin(globalMixin)
Vue.mixin(handleScrollMixin)
Vue.mixin(menuMixin)
Vue.mixin(printMixin)
Vue.component('IconMenu', IconMenuSvg)
Vue.component('IconLater', IconLaterSvg)
Vue.component('IcnNote', IconNoteSvg)
Vue.component('IcnHistory', IconHistorySvg)
Vue.component('IcnPaper', IconPaperSvg)
Vue.component('IcnList', IconListSvg)
Vue.component('IcnList2', IconList2Svg)
Vue.component('IcnTheme', IconThemeSvg)
Vue.component('IcnSearch', IconSearchSvg)
Vue.component('BackgroundImage', BackgroundImage)
Vue.component('DocumentLink', DocumentLink)
Vue.component('PCButtonHistoryBack', PCButtonHistoryBack)
Vue.component('SPButtonHistoryBack', SPButtonHistoryBack)
Vue.component('ButtonViewLater', ButtonViewLater)
Vue.component('ButtonEdit', ButtonEdit)
Vue.component('ButtonClose', ButtonClose)
Vue.component('ButtonChangePosition', ButtonChangePosition)
Vue.component('ButtonCopyOther', ButtonCopyOther)
Vue.component('IcArrowDown', IcArrowDown)
Vue.component('IcArrowLeft', IcArrowLeft)
Vue.component('IcArrowRight', IcArrowRight)
Vue.component('IcArrowTop', IcArrowTop)
Vue.component('IcBookmarkOff', IcBookmarkOff)
Vue.component('IcBookmarkOn', IcBookmarkOn)
Vue.component('IcCheck', IcCheck)
Vue.component('IcContent', IcContent)
Vue.component('IcCopy', IcCopy)
Vue.component('IcDisplay', IcDisplay)
Vue.component('IcDisplayPdf', IcDisplayPdf)
Vue.component('IcDot', IcDot)
Vue.component('IcDownload', IcDownload)
Vue.component('IcEdit', IcEdit)
Vue.component('IcEraser', IcEraser)
Vue.component('IcExpansion', IcExpansion)
Vue.component('IcFalse', IcFalse)
Vue.component('IcHidden', IcHidden)
Vue.component('IcKebabMenu', IcKebabMenu)
Vue.component('IcKey', IcKey)
Vue.component('IcLastlist', IcLastlist)
Vue.component('IcLoading', IcLoading)
Vue.component('IcMenu', IcMenu)
Vue.component('IcMinus', IcMinus)
Vue.component('IcNote', IcNote)
Vue.component('IcNotification', IcNotification)
Vue.component('IcPdf', IcPdf)
Vue.component('IcPlus', IcPlus)
Vue.component('IcPrint', IcPrint)
Vue.component('IcRanking', IcRanking)
Vue.component('IcReduction', IcReduction)
Vue.component('IcSearch', IcSearch)
Vue.component('IcSeparate', IcSeparate)
Vue.component('IcTopdown', IcTopdown)
Vue.component('IcToplist', IcToplist)
Vue.component('IcTrue', IcTrue)
Vue.component('IcWatchLater', IcWatchLater)

installGtmGaClassClickUidDelegate()

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
